import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

const resources = {
    'de-DE': {
        translation: {
            common: {
                GO_BACK: 'zurück',
                NOT_SPECIFIED: 'keine Angabe',
                OTHERS: 'Sonstiges',
                OPTIONAL: 'Optional',
                YES: 'Ja',
                NO: 'Nein',
                TIME_FORMAT: 'hh:mm:ss',
                DELETE_FILE_CONFIRMATION: 'Soll diese Datei wirklich gelöscht werden?',
                DELETE_COMMENT_CONFIRMATION: 'Soll dieser Kommentar wirklich gelöscht werden?',
                ALL: 'Alle',
                MORE: 'Mehr',
                LESS: 'Weniger',
                NOT_AVAILABLE: '-',
                CATEGORY_MATCH_DAY: '{{category}}, {{matchDayLabel}}',
                SELECT_ALL: 'Alle auswählen',
                ALL_MATCHES_SELECTED: 'Alle Spiele des Spieltags',
                SELECT_ALL_MATCHDAYS: 'Alle Spieltage auswählen',
                ALL_MATCHDAYS_SELECTED: 'Alle Spieltage ausgewählt',
                REPORT: 'Bericht'
            },
            header: {
                MENU: 'Menü',
                LOGOUT: 'Ausloggen',
                LOGOUT_USER: '{{user}} ausloggen',
                CONTACT: 'Kontakt',
                HELP: 'Hilfe'
            },
            footer: {
                IMPRINT: 'Impressum',
                PRIVACY_POLICY: 'Datenschutzerklärung',
                TERMS_OF_USE: 'Nutzungsbedingungen',
                LEGAL_NOTICE: 'Rechtliche Hinweise'
            },
            DataPrivacy: {
                I_ACCEPT_DATA_PRIVACY: 'Ich stimme den oben genannten Bedingungen zu',
                HAS_ACCEPTED_AT: 'Datenschutzerklärung zugestimmt am:',
                NOT_ACCEPTED_YET: 'Nicht zugestimmt'
            },
            commonUser: {
                username: 'E-Mail',
                password: 'Passwort'
            },
            comment: {
                COMMENT: 'Kommentieren... (tippe \'@<Buchstaben>\' um jemanden zu markieren bspw. @jas)'
            },
            validation: {
                REQUIRED: 'Bitte füllen Sie dieses Feld aus.',
                INVALID_EMAIL: 'Bitte gib eine gültige E-Mail-Adresse ein.',
                MAX_LENGTH: 'Max. {{count}} Zeichen'
            },
            login: {
                LOGIN: 'Login',
                HEADER: 'Anmelden',
                LOGIN_FAILED: 'Login war nicht erfolgreich.'
            },
            Salutation: {
                MR: 'Herr',
                MRS: 'Frau'
            },
            button: {
                CANCEL: 'Abbrechen',
                CONFIRM: 'Bestätigen',
                EDIT: 'Bearbeiten',
                SAVE: 'Speichern',
                SUBMIT: 'Abschicken',
                ADD: 'Hinzufügen',
                BACK: 'Zurück',
                NEXT: 'Weiter',
                CLOSE: 'Schließen',
                DELETE: 'Löschen',
                REMOVE: 'Entfernen'
            },
            message: {
                SAVE_SUCCESS: 'Speichern erfolgreich',
                SAVE_FAILED: 'Speichern fehlgeschlagen, bitte überprüfen Sie Ihre Eingaben. Bei weiteren Problemen wenden Sie sich bitte an Ihren Ansprechpartner.',
                DELETE_SUCCESS: 'Löschen erfolgreich',
                SEND_SUCCESS: 'E-Mail erfolgreich versendet',
                SEND_FAILED: 'E-Mail konnte nicht versendet werden',
                EDIT: 'Bearbeiten',
                CANCEL: 'Abbrechen',
                DISMISS: 'Verwerfen',
                CONFIRM: 'Bestätigen',
                CHANGE: 'Ändern',
                UNREAD_INCIDENTS: 'Es liegen {{count}} neue Vorfälle für deinen Fachbereich vor.',
                NOT_AUTHORIZED: 'Sie sind nicht für diese Aktion autorisiert.',
                OKAY_WITH_INCIDENT_NOT_POSSIBLE: '"Ja" kann nicht gewählt werden, solange noch ein Vorfall vorhanden ist.',
                EXTEND_REPORT_SUCCESS: 'Bericht wurde entsperrt'
            },
            productionsSelect: {
                PLEASE_SELECT: 'Bitte wählen Sie die betroffenen Spiele aus.'
            },
            dropdown: {
                CHOOSE: 'Bitte wähle eine Option'
            },
            error: {
                NO_ACCESS: 'Zugriff verweigert. [{method}: {url}] sollte für den aktuellen Benutzer nicht aufgerufen werden. Bitte melden Sie den Bug.',
                NOT_FOUND: 'Die angefragete Resource konnte nicht gefunden werden.',
                ERROR_CALLING_BACKEND: 'Abfrage konnte nicht bearbeitet werden [{code} - {method}: {url}]. Bitte melden Sie den Bug.',
                NO_SESSION: 'Ihre Sitzung ist abgelaufen.',
                INTERNAL_SERVER_ERROR: 'Ein unerwarteter Fehler ist aufgetreten. Bitte wenden Sie sich an den Administrator',
                REQUIRED: 'Bitte füllen Sie dieses Feld aus.',
                REQUIRED_RADIO: 'Bitte wählen Sie eine der Optionen aus.',
                REQUIRED_INCIDENT: 'Bitte legen Sie einen Vorfall an, wenn nicht alles in Ordnung war.',
                TIME_FORMAT: 'Bitte geben Sie eine Zeit im Format hh:mm:ss an.',
                DURATION_FORMAT: 'Bitte geben Sie eine Dauer im Format hh:mm:ss an.',
                CAMERA_OPERATOR: 'Bitte bewerten Sie diese Kameraperson.',
                SELECT_SUBSECTION: 'Bitte wählen sie eine Unterkategorie.',
                DROPDOWN: 'Bitte wählen sie eine Option aus'
            },
            table: {
                NEXT: 'Nächste Seite',
                PREVIOUS: 'Vorherige Seite',
                FILTER: 'Filtern'
            },
            navigation: {
                HOME: 'Startseite',
                LIVE_QM: 'Live QM',
                SUMMARY: 'Produktionsübersicht',
                REPORTS: 'Berichte',
                MY_REPORTS: 'Meine Berichte',
                ARCHIVE_REPORTS: 'Abgeschlossene Berichte',
                INCIDENT_MANAGEMENT: 'Vorfallmanagement',
                REPORTING: 'Reporting',
                CHECKLIST: 'Checkliste',
                ANALYSIS: 'Analyse',
                DEPARTMENT_MANAGER: 'Fachbereiche',
                SETTINGS: 'Einstellungen',
                EXTENSION_DEADLINE: 'Fristverlängerung'
            },
            liveQm: {
                HEADER: 'Live QM'
            },
            reports: {
                HEADER: 'Berichte',
                NON_EXISTENT: 'Dieser Bericht existiert in der gewählten Produktion nicht',
                CANNOT_SAVE: 'prüft den Bericht auf Vollständigkeit',
                SAVE_AND_FINALIZE: 'Finalisieren',
                SAVE_DRAFT: 'Entwurf speichern',
                EDIT_REPORT: 'Bericht bearbeiten',
                QUESTION_EVERYTHING_OKAY: 'War alles in Ordnung?',
                QUESTION_SERVICE_PROVIDED: 'Wurde die Leistung erbracht?',
                EXTRA_SERVICE: 'Zusatzleistungen',
                NOTE: 'Hinweis',
                PERIODS: 'Zeiten',
                ANNOTATIONS: 'Anmerkungen',
                ADD_INCIDENT: 'Vorfall hinzufügen',
                ADD_BYPASS: 'Unterbrechung hinzufügen',
                YES: 'Ja',
                NO: 'Nein',
                PRODUCTION_MANAGER: 'Production Manager',
                PRODUCTION_LOCATION: 'Produktionsort',
                DIRECTOR: 'Regie',
                BASE_DIRECTOR: 'Regie (Basis)',
                BROADCASTING_VAN_MANAGER: 'Ü-Wagenleitung',
                ADDITIONAL_BROADCASTING_VANS: 'Zusätzliche Ü-Wagen',
                SOUND_ENGINEER: 'Ton-Ing. Basis',
                BASE_SOUND_ENGINEER: 'Ton-Ing. Basis',
                BROADCASTING_VAN_NUMBER: 'Ü-Wagennummer',
                OVERVIEW: 'Überblick',
                CHANGES_NOT_SAVED: 'Änderungen nicht gespeichert',
                CONFIRM_CLOSE_UNSAVED_CHANGES_TEXT: 'Einige Änderungen im Bericht sind noch nicht gespeichert. Möchten Sie diese noch speichern?',
                CONFIRM_CLOSE_UNSAVED_CHANGES_TITLE: 'Bearbeitungsmodus verlassen',
                SAVE_CHANGES: 'Änderungen speichern',
                DROP_CHANGES: 'Änderungen verwerfen',
                SAVE_SUCCESS: 'Bericht wurde gespeichert!',
                SAVE_SUCCESS_WITH_COMPLETE: 'Der Bericht ist vollständig und wurde gespeichert',
                REPORT_EXPIRED: 'Die Bearbeitungsfrist des Berichts ist abgelaufen.',
                REPORT_EXPIRED_INCOMPLETE: 'Der Bericht wurde nicht fristgerecht vollständig ausgefüllt. Der Berichtsverantwortliche wird Sie wegen einer Fristverlängerung kontaktieren.',
                REPORT_EXPIRED_COMPLETE: 'Der Bericht wurde fristgerecht vollständig ausgefüllt.',
                NOT_ENABLED: 'Noch nicht freigegeben.',
                OTHER_NOTES: 'Sonstige Anmerkungen',
                CONTRACTOR: 'Dienstleister',
                VIRTUAL_AD_CONTRACTOR: 'VW-Dienstleister',
                SPECIAL_CAMERAS: 'Spezialkameras',
                BRIEFING: 'Vorbesprechung',
                DEBRIEFING: 'Nachbesprechung',
                BACK_TO_OVERVIEW: 'Zurück zur Übersicht',
                SNG_INFO_CARD_HEADER: 'SNG Info',
                NO_SNG_OPERATORS: 'Keine SNG Operators hinterlegt',
                SPECIAL_CAMERAS_AND_MORE: 'Sonderkameras und Zusätze (Variabel gebucht)',
                CAMERAS_BASE_PACKAGE: 'Personal Basis'
            },
            summary: {
                HEADER: 'Produktionsübersicht',
                REPORTS_COMPLETE: 'Berichte vollständig',
                REPORTS_INCOMPLETE: 'Unvollständige Berichte:',
                ALL_REPORTS_SELECTED: 'Alle Berichte ausgewählt',
                NO_REPORTS_SELECTED: 'Ausgewählte Berichte (0)',
                SELECTED_REPORTS: 'Ausgewählte Berichte',
                SELECT_ALL_REPORTS: 'Alle Berichte auswählen',
                NOTES_EXIST: 'Es gibt Hinweise in diesem Bericht',
                REPORT_NOT_COMPLETED_YET: 'Bericht noch nicht vollständig ausgefüllt',
                HIDE_REPORTS_WITHOUT_INCIDENTS: 'Berichte ohne Vorfälle ausblenden',
                NO_INCIDENTS: 'Keine Vorfälle gemeldet',
                NO_REPORTS: 'Keine Berichte vorhanden',
                CANCELED_AND_POSTPONED_MATCHES: 'Abgesagte und nachgeholte Spiele',
                IN_PROCESSING: '(In Bearbeitung)',
                DRAFT_MODE_TOOLTIP: 'Der Bericht und alle Vorfälle befinden sich noch im Entwurf'

            },
            filters: {
                SEASON: 'Saison',
                MATCH_DAY: 'Spieltag',
                SELECT_SEASON: 'Saison auswählen',
                SELECT_PRODUCTION: 'Spiel',
                SELECT_BROADCASTING_VAN_NUMBER: 'Ü-Wagen',
                SELECT_BROADCASTING_MANAGER: 'Ü-Wagenleitung',
                SELECT_SOUND_ENGINEER_NAME: 'Ton. -Ing.',
                COMPLETENESS: 'Vollständigkeit',
                INCIDENT_REPORT_ARCHIVE_STATUS: 'Vorkommnisse',
                SELECTED_SEASONS: 'Ausgewählte Saisons',
                NEED_OF_ACTION: 'Priorität',
                PERIOD: 'Zeitraum',
                SECTION: 'Themenblock',
                SEVERITY_LEVEL: 'Schweregrad',
                SEARCH: 'Suchen',
                RESET: 'Zurücksetzen'
            },
            incident: {
                NUMBER_OF_INCIDENTS: '{{count}} Vorfall',
                NUMBER_OF_INCIDENTS_plural: '{{count}} Vorfälle',
                NUMBER_OF_SEVERE_INCIDENTS: '{{count}} Störfall',
                NUMBER_OF_SEVERE_INCIDENTS_plural: '{{count}} Störfälle',
                SOLVED: 'gelöst',
                NOT_SOLVED: 'nicht gelöst',
                NO_INCIDENTS: '... keine Vorfälle bislang',
                TIME: 'Zeit',
                CAUSE: 'Ursache',
                SOLUTION: 'Lösung',
                SOLUTION_ATTEMPT: 'Lösungsversuch',
                TITLE: 'Titel',
                DESCRIPTION: 'Vorfall',
                WHAT_HAPPENED: 'Was ist geschehen?',
                IS_IT_SERIOUS: 'Ist der Vorfall gravierend?',
                TIME_FROM: 'Ortszeit von',
                TIME_UNTIL: 'Bis',
                UNTIL: 'bis',
                ERROR_TIME: 'Bitte geben Sie einen Zeitraum an.',
                APPROXIMATE_TIME: 'Zeitraum',
                COULD_THE_INCIDENT_BE_SOLVED: 'Konnte der Vorfall gelöst werden?',
                CAN_BE_CLOSED: 'Kann der Vorfall geschlossen werden?',
                COULD_BE_SOLVED: 'Konnte der Vorfall gelöst werden?',
                SAVE_AND_ADD: 'Speichern und weiteren Vorfall hinzufügen',
                DELETE: 'Vorfall löschen',
                titles: {
                    ADD_INCIDENT: '{{- sectionName}}: Vorfall anlegen',
                    EDIT_INCIDENT: '{{- sectionName}}: Vorfall bearbeiten',
                    DURATION: '{{- sectionName}}: $t(incidentDialogTab.DURATION)',
                    SOLUTION: '{{- sectionName}}: $t(incidentDialogTab.SOLUTION)',
                    ATTACHMENTS: '{{- sectionName}}: $t(incidentDialogTab.ATTACHMENTS)'
                },
                SUBSCRIBE: 'Vorfall beobachten',
                UNSUBSCRIBE: 'Beobachten beenden',
                SEVERE_INCIDENT: 'Störfall: ',
                DELETE_CONFIRMATION: 'Soll der Vorfall wirklich gelöscht werden?',
                ADDED_BY: 'Hinzugefügt von {{user}}',
                TOOLTIP_SOLUTION_FOUND_ONSITE: 'die Lösung, welche tatsächlich vor Ort gefunden wurde',
                TOOLTIP_SOLUTION_ATTEMPT: 'Hinweise für Lösungsversuche, Maßnahmen, etc',
                NEW_SEVERE_INCIDENT: 'Neuer Störfall:'
            },
            incidentDialogTab: {
                DESCRIPTION: 'Beschreibung',
                DURATION: 'Zeit & Dauer',
                SOLUTION: 'Lösung',
                ATTACHMENTS: 'Anhänge'
            },
            editIncidentDialog: {
                GENERAL: 'Allgemein',
                DESCRIPTION: 'Beschreibung',
                RESPONSIBILITY: 'Zuständigkeit',
                RATING: 'Bewertung',
                ATTACHMENTS: 'Anhänge',
                PRODUCTION: 'Produktion',
                SECTION: 'Themenblock',
                SUB_SECTION: 'Unterkategorie',
                GO_TO_REPORT: '{{reportType}} ansehen...',
                SEVERITY_LEVEL: 'Schweregrad',
                TIME_OF_OCCURRENCE: 'Uhrzeit',
                TIME_UNTIL: 'Uhrzeit Ende',
                TIME_FROM: 'Uhrzeit Beginn',
                OR: 'od.',
                APPROXIMATE_TIME: 'Ungefährer Zeitpunkt',
                ASSIGNED_TO_ACCOUNT_ID: 'Zugewiesene Person',
                DURATION: 'Dauer',
                WORKFLOW_STAGE: 'Bearbeitungsstatus',
                REPORTING_STATUS: 'Melderstatus',
                INCIDENT: 'Vorfall',
                SOLUTION: 'Lösung',
                SOLUTION_ATTEMPT: 'Lösungsversuch',
                CAUSE: 'Ursache',
                RESPONSIBLE_DEPARTMENT: 'Zust. Fachbereich',
                ASSIGNED_TO: 'Zugewiesen an',
                NEED_OF_ACTION: 'Handlungsbedarf',
                DUE_DATE: 'Fälligkeit',
                INCIDENT_TYPE: 'Fehlerart',
                INCIDENT_CATEGORY: 'Fehlertyp',
                INCIDENT_ERROR_CATEGORY: 'Fehlerkategorie',
                WEIGHT: 'Gewichtung',
                PREVENTIVE_ACTIONS: 'Präv. Maßnahmen',
                COMMENTS: 'Kommentare',
                CONSEQUENTIAL_INCIDENT: 'Fremd- oder Folgefehler',
                CREATOR_COMMENT: 'Kommentar Ausfüller',
                PRODUCTION_STAGE: 'Produktionsstufe',
                SEVERE_INCIDENT_TYPE: 'Art des Störfalls',
                SEVERE_INCIDENT_TYPE_DESCRIPTION: 'Beschreibung',
                HISTORY: 'Historie',
                TITLE: 'Titel',
                RATE_CARD_BOOKING: 'Ratecard Booking',
                TECHNICAL_SERVICE: 'Technikleistung',
                TECH_SERVICE_NAME: 'Technikleistung',
                TECH_SERVICE_PIID: 'Technikleistung',
                SPECIAL_CAMERA: 'Spezialkamera',
                STANDARD: 'Standard',
                SUBSECTION: 'Unterkategorie',
                CUSTOMER: 'Kunde'
            },
            incidentRating: {
                RATING: 'Bewertung',
                NO_RATING_DONE: 'Noch keine Bewertung vorgenommen',
                INCIDENT_TYPE: 'Fehlerart',
                INCIDENT_CATEGORY: 'Fehlertyp',
                INCIDENT_ERROR_CATEGORY: 'Fehlerkategorie',
                WEIGHT: 'Gewichtung',
                CONSEQUENTIAL_INCIDENT: 'Fremd- oder Folgefehler',
                PREVENTIVE_ACTIONS: 'Präv. Maßnahmen'
            },
            reportingStatus: {
                SOLVED: 'gelöst',
                UNSOLVED: 'nicht gelöst'
            },
            incidentLinks: {
                LINKS: 'Verknüpfte Vorfälle',
                RESULTING_FROM: 'Resultiert aus',
                CAUSING: 'Verursacht',
                DELETE_INCIDENT_LINK: 'Soll diese Verknüpfung wirklich entfernt werden?'
            },
            incidentHistory: {
                CREATED: 'Vorfall angelegt.',
                CREATED_SEVERE_INCIDENT: 'Störfall angelegt.',
                UPDATED_FIELD: '{{additionalInfo}} geändert.',
                ADDED_FILE: 'Datei(en) hinzugefügt: {{additionalInfo}}',
                REMOVED_FILE: 'Datei \'{{additionalInfo}}\' gelöscht.',
                ADDED_LINK: 'Vorfall verknüpft: ',
                REMOVED_LINK: 'Verknüpfung zu Vorfall \'{{linkedIncident.id}} - {{linkedIncident.title}}\' entfernt.',
                ADDED_COMMENT: 'Kommentar hinzugefügt.',
                REMOVED_COMMENT: 'Kommentar gelöscht.',
                UPDATED_COMMENT: 'Kommentar bearbeitet.',
                READ: 'Als gelesen markiert.',
                AND: ' und '
            },
            incidentManagement: {
                CHOOSE_SECTION: 'Themenblock',
                LOAD_MORE: 'Mehr laden',
                DUE_SOON_TOOL_TIP: 'innerhalb der nächsten 5 Tage',
                LAYOUT: 'Layout:',
                MATCHES: '{{matches}}/{{matchCount}} Spiele betroffen',
                DOWNLOAD: 'Download',
                REPORT_INFO: 'Bericht: {{reportName}}',
                FILLED_BY: 'Ausgefüllt von: {{creator}}',
                HAS_COMMENTS: 'Es gibt Kommentare zu diesem Vorfall'
            },
            WorkflowStage: {
                OPEN: 'Offen',
                SOLVED: 'Gelöst',
                IN_PROGRESS: 'In Arbeit',
                NOT_SOLVABLE: 'Nicht lösbar'
            },
            SeverityLevelTooltip: {
                MILD: 'Minderschwerer Vorfall',
                MEDIUM: 'Gravierender Vorfall',
                SEVERE: 'Störfall'
            },
            NeedOfActionTooltip: {
                HIGH: 'Hoher Handlungsbedarf',
                MEDIUM: 'Mittlerer Handlungsbedarf',
                LOW: 'Niedriger Handlungsbedarf'
            },
            ApproximateTime: {
                PREPARATION_ONSITE: 'Aufbau/Vorbereitung Onsite',
                PRE: 'Vorlauf',
                FIRST_HALF: 'Erste Halbzeit',
                PAUSE: 'Pause',
                SECOND_HALF: 'Zweite Halbzeit',
                POST: 'Nachlauf',
                WHOLE_PRODUCTION: 'Gesamte Produktion'
            },
            ReportType: {
                DL: 'DL-Bericht',
                PM: 'PM-Bericht',
                DIRECTOR: 'Regie-Bericht',
                SIGNAL_EVALUATION: 'Signalbewertung',
                PRODUCTION: 'Produktions-Bericht',
                VIRTUAL_ADVERTISEMENT: 'Virtuelle-Werbung-Bericht',
                CONTRIBUTION: 'Kontribution',
                BROADCASTING_VAN: 'Ü-Wagen',
                DFB_CONTRIBUTION: 'Kontribution DFB-Pokal'

            },
            Department: {
                MEDIA_OPERATIONS: 'Media Op.',
                TV_PRODUCTIONS: 'TV Production',
                DISTRIBUTION: 'Contribution & Distribution',
                INTERNATIONAL_PRODUCTIONS: 'Int. Productions',
                DFL_MEDIA_HUB: 'DFL Media Hub',
                TPM: 'TPM',
                EDITORIAL_DEVELOPMENT: 'Editorial Dev.',
                CUSTOMER_RELATIONS: 'Customer Rel.',
                PROJECT_CONTROLLING: 'Project Contr.',
                BUSINESS_DEVELOPMENT: 'Business Dev.',
                TECHNICAL_DEVELOPMENT: 'Technical Dev.'
            },
            production: {
                MATCH_DAY: 'Spieltag',
                POSTPONED: 'Nachholspiel',
                INTERNATIONAL: 'International',
                CANCELED: 'Abgesagt',
                CANCELED_TAG: 'Nachholtermin',
                POSTPONED_TAG: 'nachgeholt',
                NO_DATE: 'Kein Termin'

            },
            ProductionStage: {
                PRODUCTION_ON_SITE: 'Produktion vor Ort',
                CONTRIBUTION: 'Kontribution',
                CENTRAL_PRODUCTION: 'Zentrale Produktion',
                DISTRIBUTION: 'Distribution'
            },
            task: {
                TASKS: '{{count}} Aufgaben'
            },
            user: {
                FIRST_NAME: 'Vorname',
                LAST_NAME: 'Nachname',
                EMAIL: 'E-Mail',
                PHONE: 'Tel. Festnetz',
                MOBILE: 'Mobil',
                DEPARTMENT: 'Fachbereich',
                TYPE: 'Anwendertyp',
                ROLE: 'Rolle',
                LINKED_PERSON: 'Personaleintrag (PLAN-IT)',
                LINKED_CATEGORY: 'Wettbewerb',
                LINKED_CUSTOMER: 'Kunde',
                LINKED_CONTRACTOR: 'Dienstleister',
                internal: {
                    ADD_HEADER: 'Interne Anwender importieren',
                    ADD_SEARCH_FIELD: 'AD-Benutzername',
                    IMPORT: 'Importieren',
                    INVITE: 'Speichern und einladen',
                    IMPORT_SUCCESS: '{{account.lastName}}, {{account.firstName}} wurde erfolgreich importiert.',
                    INITIALS: 'Kürzel',
                    REIMPORT: 'Erneut importieren',
                    DEACTIVATE: 'Konto deaktivieren',
                    REACTIVATE: 'Konto reaktivieren'
                },
                external: {
                    ADD_EXTERNAL_USER: 'Externen Anwender hinzufügen',
                    EDIT_EXTERNAL_USER: 'Externen Anwender bearbeiten',
                    ADD_SEARCH_FIELD: 'E-Mail Adresse',
                    FIRST_NAME: 'Vorname',
                    LAST_NAME: 'Nachname',
                    EMAIL: 'E-Mail',
                    PHONE_NUMBER: 'Telefon',
                    DEPARTMENT: 'Fachbereich',
                    USER_TYPE: 'Anwendertyp',
                    ROLE: 'Rolle',
                    RESEND_INVITE: 'Einladungslink erneut versenden',
                    DEACTIVATE_ACCOUNT: 'Konto deaktivieren',
                    REACTIVATE_ACCOUNT: 'Konto reaktivieren',
                    SAVE_AND_INVITE: 'Speichern und einladen',
                    SAVE: 'Speichern',
                    CHANGE_EMAIL: 'Sportcast-Anwender müssen als interne Anwender hinzugefügt werden',
                    EMAIL_NOT_FREE: 'E-Mail wird bereits verwendet',
                    EMAIL_INVALID: 'Keine gültige E-Mail-Adresse',
                    SALUTATION: 'Anrede',
                    NOT_AVAILABLE: '-',
                    DEACTIVATE: 'Konto deaktivieren',
                    REACTIVATE: 'Konto reaktivieren'
                }
            },
            SeverityLevel: {
                MILD: 'Minderschwerer Vorfall',
                MEDIUM: 'Gravierender Vorfall',
                SEVERE: 'Störfall'
            },
            SevereIncidentType: {
                GAME_INTERRUPTION: 'Spielunterbrechung',
                GAME_CANCELLATION: 'Spielabbruch',
                KICKOFF_DELAY: 'Verspätung der Anstoßzeit von mehr als 5 Minuten',
                MAJOR_TECHNICAL_PROBLEMS: 'Erhebliche technische Probleme der Produktion',
                OTHER_MAJOR_DISRUPTIONS: 'Sonstige erhebliche Störungen oder Unterbrechungen',
                SATELLITE_SIGNAL_MISSING: 'Satellitensignal/e fehlt/ fehlen, sind unterbrochen',
                FAULTY_IMAGE: 'Satellit/ Glasfaser Fehlerhaftes Bild (Freeze/Schwarzbild)',
                SIGNAL_MISSING_CONTRIBUTION: 'Signal(e) fehlen in der Kontribution',
                MAJOR_TECHNICAL_ISSUE_PRODUCTION: 'Größerer technischer Fehler Produktion (Schwarzbild, größere Tonprobleme, fehlende Grafik, …)',
                FAULTY_DISTRIBUTION: 'Fehlerhafte Distribution',
                PROLONGED_OUTAGE: 'Längerer Ausfall / Bypass virtuelle Werbung',
                GLASS_FIBER_INTERRUPTION: 'Glasfaser ist unterbrochen / Signal/e fehlt/fehlen',
                SATELLITE_SIGNAL_FAULTY: 'Satellitensignal fehlerhaft (Freeze/Schwarzbild/ kompletter Abbruch)',
                STREAMING_INTERRUPTION: 'Streaming ist unterbrochen (Freeze/Schwarzbild/ kompletter Abbruch)'
            },
            SevereIncidentModal: {
                TYPE_OF_SEVERE_INCIDENT: 'Art des Störfalls',
                NAMING_OF_CAUSE: 'Benennung der Ursache',
                TIME_OF_OCCURRENCE: 'Zeitpunkt des Auftretens',
                TIME_UNTIL: 'Bis',
                DURATION_OF_SEVERE_INCIDENT: 'Dauer des Störfalls',
                COMMENT: 'Kommentar',
                DESCRIBE_HERE: 'Hier beschreiben',
                SOLUTION: 'Lösung',
                EDIT_SEVERE_INCIDENT: 'Störfall bearbeiten'
            },
            UserRole: {
                SPORTCAST: 'Sportcast',
                PM_INTERNAL: 'PM',
                PM_EXTERNAL: 'PM/Aufnahmeleiter (extern)',
                PARTNER: 'Partner',
                DIRECTOR: 'Regie',
                MEDIA_PARTNER: 'Medienpartner',
                DL: 'DL',
                ADMIN: '$t(UserType.ADMIN)',
                QM_RESPONSIBLE: '$t(UserType.QM_RESPONSIBLE)',
                USER: '$t(UserType.USER)',
                CUSTOM: '$t(UserType.CUSTOM)',
                EMPTY_USER_MASK: '$t(UserType.CUSTOM)',
                COORDINATOR: '$t(UserType.COORDINATOR)'
            },
            UserType: {
                ADMIN: 'Admin',
                QM_RESPONSIBLE: 'QM Verantwortlich',
                USER: 'Benutzer',
                CUSTOM: 'Benutzerdefiniert',
                COORDINATOR: 'Koordinator'
            },
            DepartmentDropdown: {
                MEDIA_OPERATIONS: 'Media Operations',
                TV_PRODUCTIONS: 'TV Productions',
                DISTRIBUTION: 'Contribution & Distribution',
                INTERNATIONAL_PRODUCTIONS: 'Int. Productions',
                DFL_MEDIA_HUB: 'DFL Media Hub',
                TPM: 'TPM',
                EDITORIAL_DEVELOPMENT: 'Editorial Development',
                CUSTOMER_RELATIONS: 'Customer Relations',
                PROJECT_CONTROLLING: 'Project Controlling',
                BUSINESS_DEVELOPMENT: 'Business Development',
                TECHNICAL_DEVELOPMENT: 'Technical Development'
            },
            NeedOfAction: {
                HIGH: 'Hoch',
                MEDIUM: 'Mittel',
                LOW: 'Niedrig'
            },
            IncidentType: {
                HUMAN: 'Human Error',
                TECHNICAL: 'Technical Error',
                INFRASTRUCTURAL: 'Infrastructural Error'
            },
            ReportSection: {
                THREE_G_HDR: '3G_HDR',
                ACCREDITATION_MST: 'Akkreditierung/MST',
                WORKPLACE: 'Arbeitsplatz',
                BASE_AND_SPECIAL_CAMERAS: 'Basis',
                PRODUCTION_PROCESS_IMPACT: 'Beeinflussung von Produktionsabläufen',
                IMAGE: 'Bild',
                CLUB: 'Club',
                DATA: 'Daten',
                DATA_COLLECTION: 'Datenerhebung',
                COMMUNICATION_TELEPHONY: 'Kommunikation Telefonie',
                DATA_COLLECTION_DELTATRE: 'Datenerhebung Deltatre',
                DFL_DL_INFRASTRUCTURE: 'DFL-/DL-Infrastruktur',
                DISTRIBUTION: 'Distribution',
                USED_TECHNOLOGY: 'Eingesetzte Technologie',
                EVENT_DATA: 'Ereignisdaten',
                FAST: 'FAST',
                FIBER: 'Fiber',
                GAT: 'GAT',
                DOLBY_ATMOS: 'ggf. Dolby Atmos',
                THREE_D_AUDIO: '3D Audio',
                GRAPHIC: 'Grafik',
                HD: 'HD',
                HD_SDR: 'HD_SDR',
                HIGHLIGHT_SHOWS: 'Highlightshows',
                INFRASTRUCTURE: 'Infrastruktur',
                INTERNATIONAL: 'International',
                COMMUNICATION: 'Kommunikation',
                CONTRIBUTION: 'Kontribution',
                CONTRIBUTION_FIBER: 'Kontribution Fiber',
                LIVE_PRODUCTION: 'Live-Produktion',
                MATCHDAY: 'Matchday',
                MKT_DISCREET: 'MKT diskret',
                MOP: 'MOP (pre & post)',
                NATIONAL_MEDIA_PARTNER: 'Nationale Medienpartner',
                NETCAST: 'Netcast',
                PRODUCTION_PROCESS_AND_ORGANIZATION: 'Produktionsablauf und Organisation',
                EVALUATION: 'Personalbewertung',
                POSITIVE_PRODUCTION_NOTE: 'Positive Produktionsanmerkungen',
                POST_PRODUCTION: 'Postproduktion',
                RATE_CARD: 'Ratecard & Zusatzleistungen',
                EDITING: 'Redaktion',
                SATELLITE: 'Satellit',
                CUT: 'Schnitt',
                SCOUTING_FEED: 'Scouting Feed',
                SDV: 'SDV',
                SNG: 'SNG',
                OTHER_TRADES: 'Sonstige Gewerke',
                OTHER_INTERNATIONAL_ACTIVITIES_ONSITE: 'Sonstige Internationale Aktvitäten ',
                OTHER: 'Sonstiges',
                STADIUM_INFRASTRUCTURE: 'Stadioninfrastruktur',
                STEREO_DOWN_MIX: 'Stereo-Downmix',
                STREAMING: 'Streaming',
                TEAMWORK: 'Teamarbeit',
                TECHNOLOGY: 'Technik',
                TEST_ASSESSMENT: 'Testbewertung',
                TEST_EXECUTION: 'Testdurchführung',
                TEST_EVALUATION: 'Testevaluierung',
                SOUND: 'Ton',
                GOAL_AREA_CAMERA: 'Torraumkamera',
                TRACKING_DATA: 'Trackingdaten',
                UHD: 'UHD',
                HDR: 'UHD/HDR',
                THREE_G_HDR_VIDEO: '3G/HDR',
                UNILATERAL: 'Unilateral',
                VA: 'VA',
                VIDEO: 'Video',
                VIDEO_ASSIST: 'Video Assist (VA)',
                VIRTUAL_ADS: 'Virtuelle Werbung',
                BRIEFING_DEBRIEFING: 'Vor - und Nachbesprechung',
                DFB_BASE_AND_SPECIAL_CAMERAS: 'Basis (DFB)',
                INTERNATIONAL_PRODUCTION_LIVE_MATCHES_AND_HIGHLIGHTS: 'Internationale Produktion (Live-Spiele und Highlights)',
                CONTRIBUTION_SNG: 'Kontribution/SNG',
                ADDED_BY: 'Hinzugefügt von {{mediapartner}}',
                CONTACT_SECTION: {
                    NAME: 'Kontrolleur',
                    PHONE: 'Telefonnummer',
                    EMAIL: 'Email'
                },
                SATELLITE_SNG_SECTION: {
                    NAME: 'Operator',
                    PHONE: 'Telefonnummer',
                    IDENTIFIER: 'Kennung'
                },
                SIGNAL_EVALUATION: {
                    VIDEO: {

                        INFLUENCE_FACTOR: 'Einflussfaktoren',
                        INFLUENCE_FACTOR_TOOLTIP: 'z.B. Sonne, Schlagschatten, Regen, Nebel, Schnee, Pyro',
                        MATCHING: 'Matching',
                        MATCHING_TOOLTIP: 'z.B. einheitliche Bildeinstellungen, Abstimmung der verschiedenen Quellen, etc.',
                        IMPRESSION: 'Bildeindruck',
                        IMPRESSION_TOOLTIP: 'z.B. Dynamikumfang, Zeichnung, Farbräume, etc.',
                        MEASURED_VALUES: 'Messwerte',
                        MEASURED_VALUES_TOOLTIP: 'z.B. Rasenpegel, Clipping, etc.',
                        OVERALL_JUDGMENT: 'Gesamturteil',
                        OVERALL_JUDGMENT_TOOLTIP: 'inkl. Verbesserungsmöglichkeiten, Sonstiges, etc.'
                    },
                    AUDIO: {
                        INFLUENCE_FACTOR: 'Einflussfaktoren',
                        INFLUENCE_FACTOR_TOOLTIP: 'z.B. Prasseln durch Regen, Knallgeräusche durch Pyro, Auslösende Remote-Fotokameras, sirrende LED-Banden, überdeutlich präsente Trommler/Schreier, etc.',
                        MATCHING: 'Abbildungsrichtigkeit',
                        MATCHING_TOOLTIP: ' z.B. korrekte Platzierung der Fangruppen, keine Bild-/Tonscheren bei Opener/Closer/Spielertunnel/Seitenwahl/Publikum, etc.',
                        IMPRESSION: 'Mischungseindruck',
                        IMPRESSION_TOOLTIP: 'z.B. Gleichmäßigkeit, Ausgewogenheit, Klangfarbe, Präsenz der Surroundkanäle und Closeballs, etc.',
                        MEASURED_VALUES: 'Messwerte',
                        MEASURED_VALUES_TOOLTIP: 'z.B. Tonspurbelegung, Synchronität, Lautheit, etc.',
                        OVERALL_JUDGMENT: 'Gesamturteil',
                        OVERALL_JUDGMENT_TOOLTIP: ' z.B. Klangbild inkl. Verbesserungsmöglichkeiten, Sonstiges, etc.'
                    },
                    INPUT_PLACEHOLDER: 'Text hinzufügen'
                },
                CAMERA_EVALUATION: 'Kamerabewertung',
                SATELLITE_EBU: 'Satellit (Eurovision)',
                SATELLITE_TVN_SNG: 'Satellit (SNG)',
                SATELLITE_CPC: 'Satellit (CPC)',
                COMMUNICATION_PHONE_CPC: 'Kommunikation & Telefonie (CPC)',
                FIBER_CPC: 'Fiber (CPC)',
                FIBER_VIDI: 'Fiber (VIDI)',
                NETCAST_VIDI: 'Netcast (VIDI)',
                DELTATRE_VIDI: 'Datenerhebung Deltatre (VIDI)',
                FAST_VIDI: 'Fast (VIDI)',
                LOW_LATENCY_STREAMING_VIDI: 'Low Latency Streaming (VIDI)',
                HD_CONTACT_AUDIO: 'Kontaktdaten Audio',
                HD_CONTACT_VIDEO: 'Kontaktdaten HD-Video',
                HDR_CONTACT_VIDEO: 'Kontaktdaten HDR-Video',
                HD_AUDIO: 'Audio',
                HD_EVALUATION_AUDIO: 'Bewertung Audio',
                HD_EVALUATION_VIDEO: 'Bewertung HD-Video',
                HDR_EVALUATION_VIDEO: 'Bewertung HDR-Video',
                HD_VIDEO: 'HD-Video',
                HDR_VIDEO: 'HDR-Video',
                ADDITIONAL_SERVICES: 'Zusatzleistungen',
                ACCREDITATION: 'Akkreditierung',
                SPECIAL_CAMERAS_AND_SERVICES: 'Spezialkameras und Services',
                CAMERA_SERVICE_SUBSECTION: 'Kameraservice',
                CAMERA_POSITIONS: 'Kamerapositionen',
                INTERVIEWS: 'Interviews',
                RECORDING: 'Aufzeichnung',
                STANDARDS: 'Standards',
                VENUE_NOTE: 'Spielortnotiz',
                HD_ATTACHMENT_AUDIO: 'Anhang Audio',
                HD_ATTACHMENT_VIDEO: 'Anhang HD-Video',
                HDR_ATTACHMENT_VIDEO: 'Anhang HDR-Video',
                FIBER_MTI: 'Fiber (MTI)',
                SNG_OPERATOR_SATELLITE: 'SNG Operator Satellit'

            },
            SpecialCameraSection: {
                BOOKED_SPECIAL_CAMERAS: 'Gebuchte Spezialkameras',
                NONE: 'Keine'
            },
            RateCardBookingSection: {
                RATECARD_SERVICES: 'Ratecardleistungen',
                ADDITIONAL_SERVICES: 'Zusatzleistungen vor Ort'
            },
            AdditionalService: {
                ADD_ADDITIONAL_SERVICE: 'Zusatzleistung hinzufügen',
                ADD_ADDITIONAL_SERVICE_ON_SITE: 'Zusatzleistung vor Ort hinzufügen',
                SERVICE: 'Leistung',
                AMOUNT: 'Menge',
                ORDER_BY: 'Bestellt durch',
                LINKED_CUSTOMER: 'Kunde',
                RECEIVER: 'Ausgehändigt an',
                RECEIVER_LABEL: 'Firma / Name',
                DELETE_CONFIRMATION: 'Soll diese Zusatzleistung wirklich entfernt werden?'
            },
            KickOffTimesSection: {
                NTH_HALF: '{{number}}. Halbzeit',
                DELAY: 'Verzögerungsgrund',
                REFEREE: 'Hauptschiedsrichter'
            },
            SecondaryIncidentFilter: {
                ALL: 'Alle ({{count}})',
                ASSIGNED_TO_ME: 'Mir zugewiesen ({{count}})',
                ASSIGNED_TO_DEPARTMENT: 'Mein Fachbereich ({{count}})',
                DUE_SOON: 'Bald fällig ({{count}})',
                SUBSCRIBED: 'Beobachtet ({{count}})',
                UNREAD: 'Ungelesen ({{count}})'
            },
            errorCode: {
                100: 'Es ist ein unbekannter Fehler aufgetreten.',
                1001: 'Es konnten keine Berichte gefunden werden.',
                1002: 'Fehlender Parameter.',
                1003: 'Fehler: ungültiger Parameter.',
                1007: 'Sie sind nicht für diese Aktion autorisiert.',
                1011: 'Es ist zu spät für diese Produktion einen Bericht anzulegen.',
                1012: 'Dieser Bericht ist nicht definiert.',
                1014: 'Dieser Bericht ist für diese Kategorie nicht freigeschaltet.',
                1016: 'Leider liegen für den Wettbewerb keine default Filtereinstellungen vor.',
                1017: 'Entschuldigung, es konnte keine passende Berechtigung gefunden werden. Bitte kontaktieren Sie den Administrator für weitere Unterstützung und Informationen.',
                1018: 'Dateiformat nicht zugelassen.',
                1019: 'Maximale Anzahl an Dateien überschritten',
                1020: 'Maximale Dateigröße überschritten',
                GENERAL: 'Ein Fehler ist aufgetreten.'
            },
            cameraEvaluation: {
                REQUIRED_COMMENT: 'Grund für Wertung als Learner',
                COMMENT: 'Kommentar (Optional)',
                CAMERA: 'Kamera',
                GRADE: 'Note',
                LEARNER: 'Learner',
                IS_LEARNER_TOOLTIP: 'Wird die Checkbox ausgewählt, fließt die Note nicht in die Durchschnittsbewertung der Person ein.',
                NOT_ASSESSABLE: 'n.b. keine Basis'
            },
            Grades: {
                PLUS_ONE: '1+',
                ONE: '1',
                MINUS_ONE: '1-',
                PLUS_TWO: '2+',
                TWO: '2',
                MINUS_TWO: '2-',
                PLUS_THREE: '3+',
                THREE: '3',
                MINUS_THREE: '3-',
                PLUS_FOUR: '4+',
                FOUR: '4',
                MINUS_FOUR: '4-',
                PLUS_FIVE: '5+',
                FIVE: '5',
                MINUS_FIVE: '5-',
                SIX: '6'
            },
            CameraPositions: {
                // camaraOperator cameras
                CAMERA_1: 'Kamera 1',
                CAMERA_2: 'Kamera 2',
                MID_FLAT_SSL: 'Mitte flach SSL',
                FLAT_16_TRIPOD_ORBITER: '16er flach Stativ/Orbiter',
                BACK_GATE_HIGH: 'Hintertor hoch',
                HIGH_16: '16er hoch',
                HAND_CAM: 'Handkamera',
                DL_HAND_CINESTYLE: 'DL Hand Cinestyle',
                BACK_GATE_FLAT: 'Hintertor flach',
                BACK_GATE_FLAT_SSL: 'Hintertor flach SSL',
                BACK_GATE_FLAT_USM: 'Hintertor flach USM',
                REVERSE: 'Reverse',
                REVERSE_OBSERVATION: 'Reverse Beobachtung',
                REVERSE_SSL: 'Reverse SSL',
                REVERSE_USM: 'Reverse USM',
                CAMERA_1_MOVING: 'Kamera 1 bewegt',
                HOTHEAD: 'Hothead',
                FREE_POSITIONED_SSL: 'Freipositionierte SSL',
                SPECIAL_CAMERA: 'Spezialkamera',
                //planIt PersonService and TechServices
                ACS_AR: 'ACS AR',
                AERIAL_CAMERA_SYSTEM: 'Aerial Camera System',
                AR_DRONE: 'AR-Drohne',
                AR_HD: 'AR HD',
                AR_UHD: 'AR UHD',
                CAMERA_OPERATOR_HIGHSPEED: 'Kamera Highspeed',
                CORNER_FLAG_CAM: 'Eckfahnenkamera',
                DRONE: 'Drohne',
                HELICOPTER_CAM: 'Helikopter-Kamera',
                PACKAGE_OPERATOR: 'Package Operator',
                POLECAM_INCL_OPERATOR: 'Polecam inkl. Operator',
                POLECAM_OPERATOR_WITH_EQUIPMENT: 'Polecam Operator mit Ausstattung',
                ROBOTIC_CAM: 'Robotic Camera',
                SLOMO_OPERATOR: 'Slomo Operator',
                SLOMO_OPERATOR_HIGHSPEED: 'Slomo Operator Highspeed',
                SLOMO_OPERATOR_LEARNER: 'Slomo Operator Learner',
                SLOMO_OPERATOR_SSL: 'Slomo Operator SSL',
                SPIDERCAM_OPERATOR: 'Spidercam Operator',
                SPECIAL_CAMERA_OPERATOR: 'Spezialkamera Operator',
                STEADYCAM_ASSISTANT: 'Steadycam Assistent',
                STEADYCAM_OPERATOR: 'Steadycam Operator',
                STEADYCAM_OPERATOR_WITH_ASSISTANT: 'Steadycam Operator inkl. Assi',
                TOWERCAM: 'Tower Camera',
//MST personalFunctions
                ACS_CAMERA: 'ACS (Kamera)',
                ACS_PILOT: 'ACS (Pilot)',
                MULTICOPTER_CAMERA: 'Multicopter (Kamera)',
                MULTICOPTER_PILOT: 'Multicopter (Pilot)',
                POLECAM_OPERATOR: 'Polecam Operator',
                DOLLY_CAMERA: 'Dolly (Kamera)',
                DOLLY_DRIVER: 'Dolly (Fahrer)',
                NO_POSITION: 'Keine Position verfügbar'
            },
            users: {
                LIST: 'Anwender verwalten',
                SEARCH: 'Durchsuchen...',
                LASTNAME_FIRSTNAME: 'Nachname, Vorname',
                EMAIL: 'E-Mail',
                DEPARTMENT: 'Fachbereich',
                CONTRACTOR: 'DL/Medienpartner',
                TYPE: 'Anwendertyp',
                ROLE: 'Rolle',
                DEACTIVATED_TOOLTIP: 'Anwender, die sich seit über 12 Monaten nicht eingeloggt haben.',
                ADD_INTERNAL: 'Internen Nutzer importieren',
                ADD_EXTERNAL: 'Externen Nutzer hinzufügen',
                ASSIGNED: 'Zugewiesen'
            },
            UserFilter: {
                ALL: 'Alle Anwender ({{count}})',
                INTERNAL: 'Interne Anwender ({{count}})',
                EXTERNAL: 'Externe Anwender ({{count}})',
                DEACTIVATED: 'Deaktiviert ({{count}})'
            },
            checklist: {
                REPORT_SEVERE_INCIDENT: 'Störfall melden'
            },
            ChecklistNotes: {
                NOTES_ON_CHECKLISTS: 'Hinweise bei Checklisten',
                NOTES_ON_CHECKLISTS_NOTES: 'Die Hinweise werden für alle Spiele eines Spieltags in der jeweiligen Checkliste angezeigt.',
                TITLE: 'Titel',
                TITLE_PLACEHOLDER: 'Bitte wähle zuerst einen Spieltag und eine Checkliste aus.',
                PRODUCTION_STAGE_PLACEHOLDER: 'Checkliste wählen',
                ERROR_MESSAGE: 'Bitte gibt einen Titel und einen Text ein, oder entferne sie, um den Hinweis zu löschen.'
            },
            SettingsNavigation: {
                PROFILE: 'Profileinstellungen',
                USERS: 'Anwender verwalten',
                SYSTEM: 'Systemeinstellungen',
                DEPARTMENTS: 'Fachbereiche'
            },
            profile: {
                TITLE: 'Profileinstellungen',
                EDIT: 'Profil bearbeiten',
                CONTACT_DATA: 'Kontaktdaten',
                MESSAGES: 'Benachrichtigungen',
                IMPORTED_FROM_AD: '(Importiert aus AD)',
                CHANGE_DEPARTMENT: 'Fachbereich ändern'
            },
            severeIncident: {
                ADDED_BY: 'Hinzugefügt von {{user}}'
            },
            IncidentList: {
                SHOW_ALL: 'Alle anzeigen',
                BACK_TO_OVERVIEW: 'Zurück zur Übersicht'
            },
            NotificationType: {
                SEVERE_INCIDENT: 'Störfall',
                PASSED_DEADLINE: 'Hinweis auf ablaufende Frist',
                PASSED_DEADLINE_PER_REPORT: 'Abgelaufene Fristen pro Bericht',
                INCIDENT_EDITED: 'Bearbeitung von Vorfällen',
                REPORT_COMPLETED: 'Vollständig ausgefüllter Bericht'
            },
            myReports: {
                FILTER: 'Filtern',
                TITLE: 'Meine Berichte',
                CATEGORY: 'Wettbewerb',
                SEASON: 'Saison',
                MATCH_DAY: 'Spieltag',
                AIR_DATE: 'Datum',
                PRODUCTION: 'Spiel',
                REPORT: 'Bericht',
                COMPLETENESS: 'vollständig',
                SORTING: 'Sortierung',
                MATCH_DAY_ASC: 'Spieltag aufsteigend',
                MATCH_DAY_DESC: 'Spieltag absteigend',
                AIR_DATE_ASC: 'Anstoßzeit aufsteigend',
                AIR_DATE_DESC: 'Anstoßzeit absteigend',
                NON_EXISTENT: 'Es sind keine zugewiesenen Berichte vorhanden'
            },
            archiveReports: {
                TITLE: 'Abgeschlossene Berichte',
                FILTER: 'Filtern',
                CATEGORY: 'Wettbewerb',
                SEASON: 'Saison',
                MATCH_DAY: 'Spieltag',
                AIR_DATE: 'Datum',
                PRODUCTION: 'Spiel',
                REPORT: 'Bericht',
                COMPLETENESS: 'Vollständig',
                BROADCASTING_VAN_NUMBER: 'Ü-Wagen',
                BROADCASTING_MANAGER: 'Ü-Wagenleitung',
                SOUND_ENGINEER_NAME: 'Ton. -Ing.',
                REPORT_ARCHIVE_STATUS: 'Vorkommnisse',
                NON_EXISTENT: 'Es sind keine Berichte vorhanden'
            },
            IncidentReportArchiveStatus: {
                NO_INCIDENTS_OR_EXTERNAL_CAUSE_ONLY: 'nur Fremdverschulden / Folgefehler',
                HAS_INCIDENT_NOT_FOLLOW_UP_OR_EXTERNAL_CAUSE: 'mind. ein Vorfall ohne Fremdverschulden'
            },
            archivedReportCompleteFilter: {
                COMPLETE: 'Vollständig',
                INCOMPLETE: 'Unvollständig'
            },
            RateCard: {
                AMOUNT: 'Menge',
                CUSTOMER: 'Kunde'
            },
            MediaHubEmployee: {
                LEARNER: 'Learner',
                NOTE: 'Sonstige Anmerkungen',
                EMPLOYEE_NOTE: 'Kommentar (Optional)',
                ADD: 'Personal hinzufügen',
                ADD_FREE_STAFF: 'Freies Personal hinzufügen',
                NAME: 'Nachname, Vorname',
                GRADE: 'Note',
                DELETE_CONFIRMATION: 'Soll dieser Eintrag wirklich entfernt werden?'
            },
            MediaHubEmployeeJob: {
                LOGGING: 'Logging',
                SUPPORT: 'Support'
            },
            MediaHubEmployeeAttribute: {
                VAR_LOGGING_CLIPPING: 'VAR-Logging/Clipping',
                ARCHIVE_LOGGING: 'Archivlogging',
                SUPPORT_IMPORT_AND_BASE: 'Import und Basiskat.',
                SUPPORT_MP_AND_REQUESTS: 'MP und Anfragebearb.',
                PUNCTUALITY: 'Pünktlichkeit',
                APPEARANCE: 'Auftreten',
                QUALITY: 'Qualität und Eindruck gesamt'
            },
            MediaHubAddEmployeeDialog: {
                PRODUCTIONS: 'An welchen Spielen hat die Person gearbeitet?'
            },
            PersonalService: {
                CAMERA_OPERATOR: 'Kamera',
                CAMERA_OPERATOR_LEARNER: 'Kamera Learner',
                CAMERA_OPERATOR_HIGHSPEED: 'Kamera Highspeed',
                CAMERA_OPERATOR_LIGHT: 'Kamera Licht',
                SPIDERCAM_OPERATOR: 'Spidercam Operator',
                PACKAGE_OPERATOR: 'Package Operator',
                POLECAM_OPERATOR: 'Polecam Operator',
                POLECAM_OPERATOR_WITH_EQUIPMENT: 'Polecam Operator mit Ausstattung',
                SLOMO_OPERATOR: 'Slomo Operator',
                SLOMO_OPERATOR_LEARNER: 'Slomo Operator Learner',
                SLOMO_OPERATOR_HIGHSPEED: 'Slomo Operator Highspeed',
                SLOMO_OPRATOR_SSL: 'Slomo Operator SSL',
                SPECIAL_CAMERA_OPERATOR: 'Spezialkamera Operator',
                DIRECTOR: 'Regie',
                SUB_DIRECTOR: 'Regie unilateral',
                ASSISTANT_DIRECTOR: 'Regie Assi',
                PM: 'Production Manager',
                PM2: 'Production Manager (2)',
                PM_VW: 'Projektmanagement virtuelle Werbung',
                STEADYCAM_OPERATOR: 'Steadycam Operator',
                STEADYCAM_ASSITANT: 'Steadycam Assi',
                STEADYCAM_OPERATOR_WITH_ASSISTANT: 'Steadycam Operator inkl. Assi'
            },
            PersonalFunction: {
                ACS_CAMERA: 'ACS (Kamera)',
                ACS_PILOT: 'ACS (Pilot)',
                MULTICOPTER_CAMERA: 'Multicopter (Kamera)',
                MULTICOPTER_PILOT: 'Multicopter (Pilot)',
                POLECAM_OPERATOR: 'Polecam Operator',
                SOUND_ENGINEER: 'Ton-Ing. Basis',
                BROADCASTING_VAN_MANAGER: 'Ü-Wagen Leiter',
                DOLLY_CAMERA: 'Dolly (Kamera)',
                DOLLY_DRIVER: 'Dolly (Fahrer)'
            },
            IncidentExportHeader: {
                ALL: 'Alle Spalten exportieren',
                ID: 'Id',
                TITLE: 'Titel',
                SEASON: 'Saison',
                CATEGORY: 'Kategorie',
                MATCH_DAY: 'Spieltag',
                HOME_TEAM: 'Heimmannschaft',
                GUEST_TEAM: 'Gastmannschaft',
                KICKOFF_TIME: 'Anstoßzeit',
                SECTION: 'Themenblock Überkategorie',
                SUBSECTION: 'Themenblock Unterkategorie',
                CUSTOMER: 'Kunde',
                PARTNER: 'Partner',
                MEDIA_PARTNER: 'Medienpartner',
                CONTRACTOR: 'Dienstleister',
                REPORT: 'Bericht',
                SEVERITY: 'Schweregrad',
                AFFECTED_CRAFTS: 'Betroffene Gewerke',
                TIME_FROM: 'Uhrzeit von',
                TIME_UNTIL: 'Uhrzeit bis',
                APPROXIMATE_TIME: 'Ungefährer Zeitpunkt',
                WORKFLOW_STAGE: 'Status',
                DESCRIPTION: 'Beschreibung',
                CAUSE: 'Ursache',
                SOLUTION: 'Lösung',
                RESPONSIBLE_DEPARTMENT: 'Zuständiger Fachbereich',
                ASSIGNED_ACCOUNT: 'Zugewiesen an',
                NEED_OF_ACTION: 'Handlungsbedarf',
                DUE_DATE: 'Fälligkeit',
                INCIDENT_TYPE: 'Fehlerart',
                INCIDENT_CATEGORY: 'Fehlertyp',
                INCIDENT_ERROR_CATEGORY: 'Fehlerkategorie',
                WEIGHT: 'Gewichtung',
                PREVENTIVE_MEASURES: 'Präventive Maßnahmen',
                CONSEQUENTIAL_ERROR: 'Fremd- oder Folgefehler',
                LINKED_INCIDENTS: 'Verknüpfte Vorfälle',
                PRODUCTION_TITLE: 'Produktionsname',
                INTERNATIONAL_PRODUCTION_TYPE_GROUP: 'Produktionstyp',
                INTERNATIONAL_PRODUCTION_TYPE: 'Kategorie',
                UNILATERAL_SERVICES: 'Unilaterale Leistungen (Themenblock PM-Bericht)',
                BASIS: 'Basis (Themenblock PM-Bericht)',
                SOUND_ENGINEER: 'Ton-Ing. Basis',
                DIRECTOR: 'Regie',
                BROADCASTING_VAN_NUMBER: 'Ü-Wagennummer',
                BROADCASTING_VAN_MANAGER: 'Ü-Wagenleitung',
                ADDITIONAL_BROADCASTING_VANS: 'Zusätzliche Ü-Wagen',
                PM: 'Production Manager',
                VENUE: 'Produktionsort'
            },
            IncidentExportModal: {
                EXPORT_HEADER: 'Vorfälle als Excel exportieren',
                EXPORT: 'Exportieren'
            },
            PermissionModule: {
                LIVE_QM: 'Live QM',
                SUMMARY: 'Produktionsübersicht',
                CHECKLIST: 'Checklisten',
                REPORT: 'Berichte',
                REPORT_ARCHIVE: 'Abgeschlossene Berichte',
                DEPARTMENT_MANAGER: 'Fachbereichsmanager',
                INCIDENT_MANAGEMENT: 'Vorfallmanagement',
                REPORTING: 'Reporting',
                EVALUATIONS: 'Auswertungen',
                MASTER_DATA: 'Stammdatenmanagement',
                ACCOUNT_PROPERTIES: 'Kontoeinstellungen',
                HELP: 'Hilfe',
                ACCOUNT_NOTIFICATIONS: 'Benachrichtigungen',
                ADMIN: 'Admin Bereich',
                CHECKLIST_NOTE: 'Checklisten Hinweise',
                SYSTEM_SETTINGS: 'Systemeinstellungen',
                INTERNATIONAL_PRODUCTS: 'Internationale Produkte'
            },
            customRightsModal: {
                AUTHORIZED_INFO: 'Berechtigt: \n Der Anwender kann nur Produktionen sehen oder bearbeiten, auf die er über Plan-IT gebucht wurde.',
                SHOW_AND_EDIT_PERMISSIONS: 'Rechte anzeigen und bearbeiten',
                INTERNAL_USER: 'Interner Anwender',
                EXTERNAL_USER: 'Externer Anwender'
            },
            Permission: {
                READ: 'Lesen',
                WRITE: 'Schreiben',
                NONE_SELECTED: 'keine Auswahl',
                NO_ACCESS: 'Kein Zugriff',
                AUTHORIZED_READ: 'Berechtigte sehen',
                AUTHORIZED_WRITE: 'Berechtigte bearbeiten',
                ALL_READ_AUTH_WRITE: 'Alle sehen & berechtigte bearbeiten',
                PRODUCTION_NO_ACCESS: 'Kein Zugriff',
                PRODUCTION_AUTHORIZED_READ: 'Berechtigte Produktionen sehen',
                PRODUCTION_READ: 'Alle Produktionen sehen',
                PRODUCTION_AUTHORIZED_WRITE: 'Berechtigte Produktionen bearbeiten',
                PRODUCTION_ALL_READ_AUTH_WRITE: 'Alle Produktionen sehen & berechtigte bearbeiten',
                PRODUCTION_WRITE: 'Alle Produktionen bearbeiten'
            },
            RightPerReport: {
                RELEASE_ADDITIONAL_REPORTS: 'Zusätzliche Berichte freigeben'
            },
            ReportPermission: {
                NONE_SELECTED: 'Keine Auswahl',
                NO_ACCESS: 'Kein Zugriff',
                READ: 'Lesen',
                ALWAYS_FILL_OUT: 'Immer ausfüllen',
                ALWAYS_EDIT: 'Immer bearbeiten'
            },
            ReportPermissionModule: {
                DL_REPORT: 'DL-Bericht',
                PM_REPORT: 'PM-Bericht',
                DIRECTOR_REPORT: 'Regie-Bericht',
                BROADCASTING_VAN: 'Ü-Wagen',
                FIBER_REPORT: 'Fiber-Bericht',
                SKY_REPORT: 'Sky-Bericht',
                DAZN_REPORT: 'DAZN-Bericht',
                ARD_REPORT: 'ARD-Bericht',
                ZDF_REPORT: 'ZDF-Bericht',
                SPORT1_REPORT: 'Sport1-Bericht',
                MAIN_CONTROL_ROOM_REPORT: 'Hauptschaltraum-Bericht',
                MEDIA_SERVICE_REPORT: 'Media Services-Bericht',
                HD_SIGNAL_EVALUATION: 'HD Signalbewertung',
                HDR_SIGNAL_EVALUATION: 'HDR Signalbewertung',
                SIGNAL_EVALUATION: 'Signalbewertung',
                VIRTUAL_ADVERTISEMENT_REPORT: 'Virtuelle Werbung-Bericht',
                DFL_DS_INTERNATIONAL_EDITING_REPORT: 'Internationale Redaktion-Bericht (Bundesliga und 2. Bundesliga)',
                DFB_INTERNATIONAL_EDITING_REPORT: 'Internationale Redaktion-Bericht (bei Wettbewerben des DFB)',
                EBU_REPORT: 'EBU-Bericht',
                MEDIA_HUB_REPORT: 'DFL Media Hub-Bericht',
                IPP_REPORT: 'IPP-Bericht',
                IPP_EDITING_REPORT: 'IPP-Redaktionsbericht',
                STS_REPORT: 'STS-Bericht',
                MEDIA_PARTNER_REPORT: 'Medienpartner-Bericht',
                DFB_REPORT: 'DFB-Bericht',
                CONTRIBUTION_REPORT: 'Kontribution',
                DFB_CONTRIBUTION: 'Kontribution DFB-Pokal'

            },
            RoleSelector: {CUSTOM: 'Benutzerdefiniert'},
            ReportStatusBanner: {
                NOT_RELEASED: 'Noch nicht freigegeben',
                NOT_EDITED: 'Noch nicht bearbeitet',
                LAST_EDITED_BY: 'Zuletzt geändert: {{lastUpdated}} von {{firstName}} {{lastName}}',
                LAST_EDITED: 'Zuletzt geändert: {{lastUpdated}}',
                PERCENTAGE_COMPLETE: '{{percentage}}% vollständig, Bearbeitungsfrist: ',
                MEDIA_PARTNER_PUBLISHED_BY: 'Freigegeben: {{publishedAt}} von {{publishedBy}}',
                REPORT_PUBLISHING: 'Berichtsfreigaben',
                SHARE_OF_TOTAL_PUBLISHED: '{{published}}/{{total}} freigegeben',
                CLOCK: 'Uhr'
            },
            SystemSettings: {
                SYSTEM: 'System',
                CATEGORY_SELECTION: 'Wettbewerbsauswahl',
                REPORTS: 'Berichte',
                CHECKLIST_NOTES: 'Hinweise Checkliste',
                DEPARTMENT: 'Fachbereiche'
            },
            DepartmentSettings: {
                SETTINGS: 'Einstellungen',
                SELECT_DEPARTMENT: 'Fachbereich wählen',
                RESPONSIBLE: 'QM Hauptverantwortlich',
                CHOOSE: 'Auswählen',
                RESPONSIBLE_TOOLTIP: 'Der hinterlegten Person werden initial alle Vorfälle des Fachbereichs zugewiesen.',
                NO_QM_ASSIGNED: 'Dem Fachbereich sind noch keine QM-Verantwortlichen zugewiesen'
            },
            ReportSettings: {
                DEADLINE: 'Bearbeitungsfrist',
                RESPONSIBLE: 'Verantwortlich',
                RESPONSIBLE_DEPARTMENT: 'Verantwortlicher Fachbereich',
                REPORT_SETTINGS: 'Einstellungen',
                SELECT_REPORT_TYPE: 'Bericht wählen',
                WORKDAY_TOOLTIP: 'Werktage: Montag bis Freitag',
                RESPONSIBLE_DEPARTMENT_TOOLTIP: 'Noch nicht im System berücksichtigt.',
                RESPONSIBLE_TOOLTIP: 'Kann den Bericht editieren und wird bei Änderungen benachrichtigt.'
            },
            CategorySettings: {
                CATEGORY_SETTINGS: 'Wettbewerbe in Report',
                EDIT_HEADER: 'Wettbewerbe aus PLAN-IT hinzufügen',
                ALL_REPORTS: 'Alle Berichte',
                SELECTED_REPORTS: 'Ausgewählte Berichte'
            },
            WorkdayCount: {
                FOLLOWING_WORKDAY: 'Folgender Werktag',
                AFTER_TWO_WORKDAYS: 'Nach 2 Werktagen',
                AFTER_THREE_WORKDAYS: 'Nach 3 Werktagen',
                AFTER_NINETY_WORKDAYS: 'Nach 90 Werktagen'
            },
            ReportNoteSetting: {
                NOTE_HEADER: 'Hinweis',
                NOTE_BODY: 'Der Hinweis wird im Bearbeitungsmodus des Berichts angezeigt',
                INITIAL_TEXT: 'Bitte geben Sie hier den Hinweistext an...',
                TITLE: 'Titel'
            },
            ReportNoteBannerPreview: {
                TITLE: 'Hinweis überprüfen',
                SUBTITLE: 'Bitte überprüfe den Hinweis auf Vollständigkeit und Fehler.',
                RELEASE_BUTTON: 'Hinweis freigeben'
            },
            ReportNoteBanner: {
                MORE: 'Mehr',
                LESS: 'Weniger'
            },
            NoActiveLiveProduction: {
                NO_LIVE_PRODUCTIONS: 'Aktuell keine Spiele live',
                TO_MY_REPORTS: 'Möchtest du zu "Meine Berichte" wechseln?'
            },
            StandardsReportSection: {
                ADDITIONAL_SERVICES: 'Zusatzleistungen'
            },
            AdditionalServices: {
                OPEN_IN_PM_REPORT: 'Im PM-Bericht öffnen'
            },
            CameraAndSlomoReporting: {
                LASTNAME_FIRSTNAME: 'Nachname, Vorname',
                TOTAL: 'Gesamt',
                ALL_CAMERAS: 'Alle',
                ONLY_CAMERAS: 'Nur Kameras',
                SELECTED_CAMERAS: 'Ausgewählte Kameras',
                NO_CAMERAS: 'Keine Kameras gewählt',
                PICK_TIME_PERIOD: 'Zeitraum wählen',
                GRADES: 'Noten'
            },
            ExtendedCameraEvaluation: {
                MATCH_DAY: 'SPTG',
                ENCOUNTER: 'Begegnung',
                INCIDENTS: 'Vorfälle',
                VENUE: 'Austragungsort',
                DIRECTOR: 'Regisseur',
                CAMERA_POSITION: 'Kameraposition',
                IS_LEARNER: 'Learner',
                GRADE: 'Note',
                NOTE: 'Kommentar'
            },
            ExtendedCameraEvaluationConfig: {
                CATEGORY: 'Wettbewerb',
                MATCH_DAY: 'Spieltag',
                ENCOUNTER: 'Begegnung',
                INCIDENTS: 'Vorfälle',
                DIRECTOR: 'Regisseur',
                VENUE: 'Austragungsort',
                IS_LEARNER: 'Learner',
                CAMERA_POSITION: 'Kameraposition',
                GRADE: 'Note',
                NOTE: 'Kommentar'
            },
            CameraPersonDetailReporting: {
                TOTAL_GRADE: 'Gesamt: {{overallGrade}}',
                CONFIGURE_VIEW: 'Ansicht konfigurieren'
            },
            ReportingNavigation: {
                STAFF: 'Personal',
                KICK_OFF_TIMES: 'Anstoßzeiten'
            },
            Reporting: {
                REPORTING: 'Reporting',
                CAMERA: 'Kamera',
                DFL_MEDIA_HUB: 'DFL Media Hub'
            },
            NoAccess: {
                DESCRIPTION: 'Dieser Account wurde noch nicht als Benutzer in RePort registriert und hat daher keinen Zugriff.'
            },
            CategoryDropdown: {
                ALL: 'Alle Wettbewerbe'
            },
            AccountDeactivated: {
                DESCRIPTION: 'Dein Account wurde deaktiviert. Wende dich an einen Sportcast-Mitarbeiter für weitere Infos.'
            },
            DFBCupRound: {
                FIRST_ROUND: 'Runde 1',
                SECOND_ROUND: 'Runde 2',
                ROUND_OF16: 'Achtelfinale',
                QUARTER_FINAL: 'Viertelfinale',
                SEMI_FINAL: 'Halbfinale',
                FINAL: 'Finale'
            },
            Consent: {
                BUTTON_TEXT: 'Ok, verstanden',
                TEXT: 'Wir verwenden Cookies, damit du RePort bestmöglich nutzen kannst. Dabei schützen wir deine Privatsphäre und setzen nur ' +
                    'technisch erforderliche Cookies ein. Weitere Informationen findest du in unserer <1>Datenschutzerklärung</1>.'
            },
            IncompleteReport: {
                PRODUCTION_SUMMARY: 'Produktion',
                REPORT: 'Bericht',
                MISSING_REPORT_SECTION_TITLE: 'Themenblock',
                CONTRACTOR: 'Contractor',
                REPORTING_ACCOUNT: 'Ausfüller',
                EXTEND: 'Entsperren',
                TITLE: 'Fristverlängerung',
                DETAILS: 'Details'
            },
            'file-invalid-type': 'Dieses Dateiformat wird leider nicht unterstützt.',
            'file-too-large': 'Diese Datei überschreitet die maximale Dateigröße.'
        }
    }
};

i18n.use(initReactI18next)
    .init({
        fallbackLng: 'de-DE',
        lng: 'de-DE',
        debug: false,
        resources
    });

export default i18n;
